import React from 'react';
// import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';


const OpenPositionsCounter = () => {
    const { positions } = useSelector((state) => (state.account.positions.open), shallowEqual);
    const { MainColor: { ActiveText } } = useSelector((state) => (state.brand.theme));
    const openPositionsQuantity = Object.keys(positions).length;


    return (
        <div className='quantity-mark' style={{ backgroundColor: ActiveText }}>
            {openPositionsQuantity}
        </div>
    );
};

// OpenPositionsCounter.propTypes = {};

export default OpenPositionsCounter;
